import React from "react";
import { styled } from "@mui/system";
import Avatar from "../../../shared/components/Avatar";
import { Typography } from "@mui/material";
const MainContainer = styled("div")({
  width:"100%",
  display:"flex",
  marginTop:"14px",
  boxSizing:"border-box",
});

const AvatarContainer=styled("div")({
    width:"56px",
    flexShrink:0,
})

const MessageContainer=styled("div")({
    display:"flex",
    flexDirection:"column",
    minWidth:0,
    flexGrow:1,

})
const MessageContent=styled("div")({
    color:"#DCDDDE",
    lineHeight:1.45,
    overflowWrap:"anywhere",
    whiteSpace:"pre-wrap",
})
const SameAuthorMessageText=styled("span")({
    display:"block",
    marginLeft:"56px",
    lineHeight:1.45,
    overflowWrap:"anywhere",
    whiteSpace:"pre-wrap",
})
const SameAuthorMessageContent=styled("div")({
    color:"#DCDDDE",
    width:'100%',
    marginTop:"4px",
    boxSizing:"border-box",
})
const Message = ({content,sameAuthor,username,displayName,avatarUrl,date,sameDay}) => {
  if (sameAuthor && sameDay) {
    return (
       <SameAuthorMessageContent>
        <SameAuthorMessageText>{content}</SameAuthorMessageText>
       </SameAuthorMessageContent>
      )
  }
  return (
    <MainContainer>
        <AvatarContainer>
            <Avatar username={username} displayName={displayName} avatarUrl={avatarUrl} />
        </AvatarContainer>
        <MessageContainer>
            <Typography style={{fontSize:"16px",color:"white",fontWeight:600}} >{displayName || username}
          
            <span style={{fontSize:"12px",color:"#72767d",marginLeft:"8px",fontWeight:400}}>{date}</span></Typography>
        <MessageContent>{content}</MessageContent>
        </MessageContainer>
    </MainContainer>
  )
}

export default Message
